export var iconWrapper = function (borderColor) {
    return "h-full w-full rounded-full bg-".concat(borderColor);
};
export var wrapperContainer = "relative w-12 h-12 mb-3";
export var iconContainer = "absolute inset-0 flex justify-center items-center ";
//# sourceMappingURL=icon-wrapper.styles.js.map